var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sources-form',{attrs:{"source":_vm.source,"source-collections":_vm.sourceCollections,"collections":_vm.collections,"custom-parsers":_vm.customParsers}})}
var staticRenderFns = []

export { render, staticRenderFns }